export const LOADING = 'Chargement...';
export const ERROR = 'Une erreur est survenue';
export const UNABLE_TO_LOAD_FORM = 'Impossible de charger le formulaire, des informations sont manquantes';
export const LOADING_NOT_POSSIBLE = 'Chargement impossible, des informations sont manquantes';
export const MISCONFIGURED_CATCHMENT_AREA = "La zone de chalandise est mal configurée. Veuillez vérifier la configuration sur le Hektor de l'agence."
export const API_ERROR = 'API - Une erreur est survenue';
export const AUTHENTICATION_NOT_POSSIBLE = 'Authentification impossible.';
export const AUTHENTICATION_ERROR = 'Une erreur est survenue lors de l\'authentification';
export const ACTION_ERROR = 'La communication est impossible.';
export const REQUEST_CANCELED = 'Axios : Request cancelled.';
